import { useTranslation } from 'react-i18next';
import { homeStats } from '@/mocks/home';

export default function StatsStrip() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'kk';

  return (
    <section className="relative bg-background-950 border-y border-background-800/50">
      {/* Tactical grid */}
      <div className="absolute inset-0 tactical-grid opacity-20 pointer-events-none" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {homeStats.map((stat, index) => {
            const label = lang.startsWith('en') ? stat.labelEn : lang.startsWith('ru') ? stat.labelRu : stat.labelKk;
            return (
              <div
                key={stat.id}
                className="relative text-center group"
              >
                {/* Corner bracket decorations */}
                <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-accent-500/20" />
                <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-accent-500/20" />
                <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-accent-500/20" />
                <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-accent-500/20" />

                <div className="py-4 md:py-6">
                  <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 tracking-tight">
                    {stat.value}
                    <span className="text-accent-500">{stat.suffix}</span>
                  </div>
                  <div className="mt-2 text-[0.65rem] md:text-xs tracking-widest uppercase text-foreground-600 font-label">
                    {label}
                  </div>
                  <div className="mt-1 coordinate">
                    <span>IDX: 0{index + 1}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}